// extracted by mini-css-extract-plugin
export default {"messageDetail":"index_messageDetail__cs2SX"};